// Central configuration for API endpoints
// Uses CRA env var naming convention. Example usage:
// REACT_APP_API_BASE_URL=https://api.example.com
//export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://squadra-back.onrender.com/';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';


